import {Injectable} from '@angular/core';
import {EntityState, EntityStore, StoreConfig} from '@datorama/akita';
import {Tag} from './model';

export interface TagState extends EntityState<Tag> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'Tag' })
export class Store extends EntityStore<TagState> {

  constructor() {
    super();
  }

}
